export interface IDiscountTypeAPI {
  discounttype_id?: number;
  name: string;
}

export default class DiscountType {
  id: number;

  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  static fromApi(apiObject: IDiscountTypeAPI): DiscountType {
    return new DiscountType(apiObject.discounttype_id, apiObject.name);
  }

  toApi(): IDiscountTypeAPI {
    return {
      discounttype_id: this.id >= 0 ? this.id : undefined,
      name: this.name,
    };
  }
}
